import { type TableV2HostDependencies } from '@databases/frontend/table-v2-host';
import { IntlProviderWithMessages, useLocale } from '@databases/intl';
import { perf } from '@databases/logs/performance';
import React from 'react';

import AppWithQueryParamContext from './app-with-query-param-context.tsx';

const AppWithLocale = ({ tableV2Host }: { tableV2Host?: TableV2HostDependencies }) => {
  const locale = useLocale();

  perf.timeLog('app-initialization', 'app-with-locale');

  return (
    <IntlProviderWithMessages locale={locale}>
      <AppWithQueryParamContext tableV2Host={tableV2Host} />
    </IntlProviderWithMessages>
  );
};

export default AppWithLocale;
